<div [style.display]="mapVisible ? 'block' : 'none'">
  <compass-map-searchbox [setup]="searchboxSetup" [style.display]="searchboxVisible ? 'block' : 'none'"></compass-map-searchbox>

  <div class="map-container">
    <div class="map-frame">
      <div #map_elementRef [attr.id]="mapSetUp?.id || 'mapElement'" class="map-elementRef"></div>
    </div>
  </div>
</div>
